module.exports = __webpack_public_path__ + "assets/language-squares/zh-HK-48dcd8350b14e0d02b4e6659123f3219.jpg";